import { Header } from './Header';
import { Link } from './Link';
import { MenuItem } from './MenuItem';

/**
 * @package
 */
export const Container = {
  Header: Header,
  Link: Link,
  MenuItem: MenuItem,
};
